import React from 'react'
import PropTypes from 'prop-types'
import { H2 } from 'components/common/Text/Text'
import { FEATURES, BENEFITS } from '../constants'
import { Column } from '../../Common.styles'
import { hasNumericWarranty } from '../helpers'
import OverviewSection from './OverviewSection'
import WarrantyList from './WarrantyList'

const Overview = ({
  features = [],
  benefits = [],
  warranties = [],
  brandPromisePlan
}) =>
  <Column>
    <H2 data-at-sku-about-title headline_narrow headline size="20" noMargin>About this Tire</H2>
    { Boolean(features.length) && <OverviewSection list={ features } title={ FEATURES } /> }
    { Boolean(benefits.length) && <OverviewSection list={ benefits } title={ BENEFITS } /> }
    { hasNumericWarranty(warranties) && <WarrantyList warranties={ warranties } /> }
    { brandPromisePlan && <div dangerouslySetInnerHTML={{ __html: brandPromisePlan }} />}
  </Column>

export default Overview

Overview.propTypes = {
  benefits: PropTypes.arrayOf(PropTypes.string),
  brandPromisePlan: PropTypes.string,
  features: PropTypes.arrayOf(PropTypes.string),
  warranties: PropTypes.arrayOf(PropTypes.shape())
}
